import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { menuMobx, restaurantConfig } from 'restaurant'
import { recommendMobx } from '@mobxStore'
import WaterfallTemplate from '../WaterfallTemplate'
import ClassicTemplate from '../ClassicTemplate'
import CategoryBtns from '../CategoryBtns'
import './index.scss'

interface IProps {
}

const ProductTemplate: FC<IProps> = () => {
  const products = recommendMobx.products.filter(item => menuMobx.isOpenSoldout ? item.saleCnt !== 0 : true)
  return (
    <div className='product-template'>
      {
        restaurantConfig.displayMode === 'waterfall' ? (
          <>
            <WaterfallTemplate products={products} />
            {/* 底部分类btns */}
            {/* <CategoryBtns /> */}
          </>
        ) : <ClassicTemplate />
      }
    </div>
  )
}

export default observer(ProductTemplate)
